// Dispositions de claviers selon les langues (basées sur On-Screen Keyboard Windows)

export const keyboardLayouts = {
  // Français - AZERTY
  fr: {
    name: 'AZERTY (Français)',
    rows: [
      [
        { key: '²', shift: '³', display: '² ³' },
        { key: '&', shift: '1', display: '& 1' },
        { key: 'é', shift: '2', display: 'é 2' },
        { key: '"', shift: '3', display: '" 3' },
        { key: "'", shift: '4', display: "' 4" },
        { key: '(', shift: '5', display: '( 5' },
        { key: '-', shift: '6', display: '- 6' },
        { key: 'è', shift: '7', display: 'è 7' },
        { key: '_', shift: '8', display: '_ 8' },
        { key: 'ç', shift: '9', display: 'ç 9' },
        { key: 'à', shift: '0', display: 'à 0' },
        { key: ')', shift: '°', display: ') °' },
        { key: '=', shift: '+', display: '= +' }
      ],
      [
        { key: 'a', shift: 'A', display: 'a' },
        { key: 'z', shift: 'Z', display: 'z' },
        { key: 'e', shift: 'E', display: 'e' },
        { key: 'r', shift: 'R', display: 'r' },
        { key: 't', shift: 'T', display: 't' },
        { key: 'y', shift: 'Y', display: 'y' },
        { key: 'u', shift: 'U', display: 'u' },
        { key: 'i', shift: 'I', display: 'i' },
        { key: 'o', shift: 'O', display: 'o' },
        { key: 'p', shift: 'P', display: 'p' },
        { key: '^', shift: '¨', display: '^ ¨' },
        { key: '$', shift: '£', display: '$ £' }
      ],
      [
        { key: 'q', shift: 'Q', display: 'q' },
        { key: 's', shift: 'S', display: 's' },
        { key: 'd', shift: 'D', display: 'd' },
        { key: 'f', shift: 'F', display: 'f' },
        { key: 'g', shift: 'G', display: 'g' },
        { key: 'h', shift: 'H', display: 'h' },
        { key: 'j', shift: 'J', display: 'j' },
        { key: 'k', shift: 'K', display: 'k' },
        { key: 'l', shift: 'L', display: 'l' },
        { key: 'm', shift: 'M', display: 'm' },
        { key: 'ù', shift: '%', display: 'ù %' },
        { key: '*', shift: 'µ', display: '* µ' }
      ],
      [
        { key: 'w', shift: 'W', display: 'w' },
        { key: 'x', shift: 'X', display: 'x' },
        { key: 'c', shift: 'C', display: 'c' },
        { key: 'v', shift: 'V', display: 'v' },
        { key: 'b', shift: 'B', display: 'b' },
        { key: 'n', shift: 'N', display: 'n' },
        { key: ',', shift: '?', display: ', ?' },
        { key: ';', shift: '.', display: '; .' },
        { key: ':', shift: '/', display: ': /' },
        { key: '!', shift: '§', display: '! §' }
      ],
      [
        { key: ' ', display: 'Espace', special: 'space' }
      ]
    ]
  },
  
  // Anglais - QWERTY
  en: {
    name: 'QWERTY (English)',
    rows: [
      [
        { key: '`', shift: '~', display: '` ~' },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: '@', display: '2 @' },
        { key: '3', shift: '#', display: '3 #' },
        { key: '4', shift: '$', display: '4 $' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: '^', display: '6 ^' },
        { key: '7', shift: '&', display: '7 &' },
        { key: '8', shift: '*', display: '8 *' },
        { key: '9', shift: '(', display: '9 (' },
        { key: '0', shift: ')', display: '0 )' },
        { key: '-', shift: '_', display: '- _' },
        { key: '=', shift: '+', display: '= +' }
      ],
      [
        { key: 'q', shift: 'Q', display: 'q' },
        { key: 'w', shift: 'W', display: 'w' },
        { key: 'e', shift: 'E', display: 'e' },
        { key: 'r', shift: 'R', display: 'r' },
        { key: 't', shift: 'T', display: 't' },
        { key: 'y', shift: 'Y', display: 'y' },
        { key: 'u', shift: 'U', display: 'u' },
        { key: 'i', shift: 'I', display: 'i' },
        { key: 'o', shift: 'O', display: 'o' },
        { key: 'p', shift: 'P', display: 'p' },
        { key: '[', shift: '{', display: '[ {' },
        { key: ']', shift: '}', display: '] }' }
      ],
      [
        { key: 'a', shift: 'A', display: 'a' },
        { key: 's', shift: 'S', display: 's' },
        { key: 'd', shift: 'D', display: 'd' },
        { key: 'f', shift: 'F', display: 'f' },
        { key: 'g', shift: 'G', display: 'g' },
        { key: 'h', shift: 'H', display: 'h' },
        { key: 'j', shift: 'J', display: 'j' },
        { key: 'k', shift: 'K', display: 'k' },
        { key: 'l', shift: 'L', display: 'l' },
        { key: ';', shift: ':', display: '; :' },
        { key: "'", shift: '"', display: "' \"" },
        { key: '\\', shift: '|', display: '\\ |' }
      ],
      [
        { key: 'z', shift: 'Z', display: 'z' },
        { key: 'x', shift: 'X', display: 'x' },
        { key: 'c', shift: 'C', display: 'c' },
        { key: 'v', shift: 'V', display: 'v' },
        { key: 'b', shift: 'B', display: 'b' },
        { key: 'n', shift: 'N', display: 'n' },
        { key: 'm', shift: 'M', display: 'm' },
        { key: ',', shift: '<', display: ', <' },
        { key: '.', shift: '>', display: '. >' },
        { key: '/', shift: '?', display: '/ ?' }
      ],
      [
        { key: ' ', display: 'Space', special: 'space' }
      ]
    ]
  },
  
  // Allemand - QWERTZ
  de: {
    name: 'QWERTZ (Deutsch)',
    rows: [
      [
        { key: '^', shift: '°', display: '^ °' },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: '"', display: '2 "' },
        { key: '3', shift: '§', display: '3 §' },
        { key: '4', shift: '$', display: '4 $' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: '&', display: '6 &' },
        { key: '7', shift: '/', display: '7 /' },
        { key: '8', shift: '(', display: '8 (' },
        { key: '9', shift: ')', display: '9 )' },
        { key: '0', shift: '=', display: '0 =' },
        { key: 'ß', shift: '?', display: 'ß ?' },
        { key: '´', shift: '`', display: '´ `' }
      ],
      [
        { key: 'q', shift: 'Q', display: 'q' },
        { key: 'w', shift: 'W', display: 'w' },
        { key: 'e', shift: 'E', display: 'e' },
        { key: 'r', shift: 'R', display: 'r' },
        { key: 't', shift: 'T', display: 't' },
        { key: 'z', shift: 'Z', display: 'z' },
        { key: 'u', shift: 'U', display: 'u' },
        { key: 'i', shift: 'I', display: 'i' },
        { key: 'o', shift: 'O', display: 'o' },
        { key: 'p', shift: 'P', display: 'p' },
        { key: 'ü', shift: 'Ü', display: 'ü' },
        { key: '+', shift: '*', display: '+ *' }
      ],
      [
        { key: 'a', shift: 'A', display: 'a' },
        { key: 's', shift: 'S', display: 's' },
        { key: 'd', shift: 'D', display: 'd' },
        { key: 'f', shift: 'F', display: 'f' },
        { key: 'g', shift: 'G', display: 'g' },
        { key: 'h', shift: 'H', display: 'h' },
        { key: 'j', shift: 'J', display: 'j' },
        { key: 'k', shift: 'K', display: 'k' },
        { key: 'l', shift: 'L', display: 'l' },
        { key: 'ö', shift: 'Ö', display: 'ö' },
        { key: 'ä', shift: 'Ä', display: 'ä' },
        { key: '#', shift: "'", display: "# '" }
      ],
      [
        { key: 'y', shift: 'Y', display: 'y' },
        { key: 'x', shift: 'X', display: 'x' },
        { key: 'c', shift: 'C', display: 'c' },
        { key: 'v', shift: 'V', display: 'v' },
        { key: 'b', shift: 'B', display: 'b' },
        { key: 'n', shift: 'N', display: 'n' },
        { key: 'm', shift: 'M', display: 'm' },
        { key: ',', shift: ';', display: ', ;' },
        { key: '.', shift: ':', display: '. :' },
        { key: '-', shift: '_', display: '- _' }
      ],
      [
        { key: ' ', display: 'Leertaste', special: 'space' }
      ]
    ]
  },
  
  // Espagnol - QWERTY
  es: {
    name: 'QWERTY (Español)',
    rows: [
      [
        { key: 'º', shift: 'ª', display: 'º ª' },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: '"', display: '2 "' },
        { key: '3', shift: '·', display: '3 ·' },
        { key: '4', shift: '$', display: '4 $' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: '&', display: '6 &' },
        { key: '7', shift: '/', display: '7 /' },
        { key: '8', shift: '(', display: '8 (' },
        { key: '9', shift: ')', display: '9 )' },
        { key: '0', shift: '=', display: '0 =' },
        { key: "'", shift: '?', display: "' ?" },
        { key: '¡', shift: '¿', display: '¡ ¿' }
      ],
      [
        { key: 'q', shift: 'Q', display: 'q' },
        { key: 'w', shift: 'W', display: 'w' },
        { key: 'e', shift: 'E', display: 'e' },
        { key: 'r', shift: 'R', display: 'r' },
        { key: 't', shift: 'T', display: 't' },
        { key: 'y', shift: 'Y', display: 'y' },
        { key: 'u', shift: 'U', display: 'u' },
        { key: 'i', shift: 'I', display: 'i' },
        { key: 'o', shift: 'O', display: 'o' },
        { key: 'p', shift: 'P', display: 'p' },
        { key: '`', shift: '^', display: '` ^' },
        { key: '+', shift: '*', display: '+ *' }
      ],
      [
        { key: 'a', shift: 'A', display: 'a' },
        { key: 's', shift: 'S', display: 's' },
        { key: 'd', shift: 'D', display: 'd' },
        { key: 'f', shift: 'F', display: 'f' },
        { key: 'g', shift: 'G', display: 'g' },
        { key: 'h', shift: 'H', display: 'h' },
        { key: 'j', shift: 'J', display: 'j' },
        { key: 'k', shift: 'K', display: 'k' },
        { key: 'l', shift: 'L', display: 'l' },
        { key: 'ñ', shift: 'Ñ', display: 'ñ' },
        { key: '´', shift: '¨', display: '´ ¨' },
        { key: 'ç', shift: 'Ç', display: 'ç' }
      ],
      [
        { key: 'z', shift: 'Z', display: 'z' },
        { key: 'x', shift: 'X', display: 'x' },
        { key: 'c', shift: 'C', display: 'c' },
        { key: 'v', shift: 'V', display: 'v' },
        { key: 'b', shift: 'B', display: 'b' },
        { key: 'n', shift: 'N', display: 'n' },
        { key: 'm', shift: 'M', display: 'm' },
        { key: ',', shift: ';', display: ', ;' },
        { key: '.', shift: ':', display: '. :' },
        { key: '-', shift: '_', display: '- _' }
      ],
      [
        { key: ' ', display: 'Espacio', special: 'space' }
      ]
    ]
  },
  
  // Italien - QWERTY
  it: {
    name: 'QWERTY (Italiano)',
    rows: [
      [
        { key: '\\', shift: '|', display: '\\ |' },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: '"', display: '2 "' },
        { key: '3', shift: '£', display: '3 £' },
        { key: '4', shift: '$', display: '4 $' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: '&', display: '6 &' },
        { key: '7', shift: '/', display: '7 /' },
        { key: '8', shift: '(', display: '8 (' },
        { key: '9', shift: ')', display: '9 )' },
        { key: '0', shift: '=', display: '0 =' },
        { key: "'", shift: '?', display: "' ?" },
        { key: 'ì', shift: '^', display: 'ì ^' }
      ],
      [
        { key: 'q', shift: 'Q', display: 'q' },
        { key: 'w', shift: 'W', display: 'w' },
        { key: 'e', shift: 'E', display: 'e' },
        { key: 'r', shift: 'R', display: 'r' },
        { key: 't', shift: 'T', display: 't' },
        { key: 'y', shift: 'Y', display: 'y' },
        { key: 'u', shift: 'U', display: 'u' },
        { key: 'i', shift: 'I', display: 'i' },
        { key: 'o', shift: 'O', display: 'o' },
        { key: 'p', shift: 'P', display: 'p' },
        { key: 'è', shift: 'é', display: 'è é' },
        { key: '+', shift: '*', display: '+ *' }
      ],
      [
        { key: 'a', shift: 'A', display: 'a' },
        { key: 's', shift: 'S', display: 's' },
        { key: 'd', shift: 'D', display: 'd' },
        { key: 'f', shift: 'F', display: 'f' },
        { key: 'g', shift: 'G', display: 'g' },
        { key: 'h', shift: 'H', display: 'h' },
        { key: 'j', shift: 'J', display: 'j' },
        { key: 'k', shift: 'K', display: 'k' },
        { key: 'l', shift: 'L', display: 'l' },
        { key: 'ò', shift: 'ç', display: 'ò ç' },
        { key: 'à', shift: '°', display: 'à °' },
        { key: 'ù', shift: '§', display: 'ù §' }
      ],
      [
        { key: 'z', shift: 'Z', display: 'z' },
        { key: 'x', shift: 'X', display: 'x' },
        { key: 'c', shift: 'C', display: 'c' },
        { key: 'v', shift: 'V', display: 'v' },
        { key: 'b', shift: 'B', display: 'b' },
        { key: 'n', shift: 'N', display: 'n' },
        { key: 'm', shift: 'M', display: 'm' },
        { key: ',', shift: ';', display: ', ;' },
        { key: '.', shift: ':', display: '. :' },
        { key: '-', shift: '_', display: '- _' }
      ],
      [
        { key: ' ', display: 'Spazio', special: 'space' }
      ]
    ]
  },
  
  // Portugais - QWERTY
  pt: {
    name: 'QWERTY (Português)',
    rows: [
      [
        { key: '\\', shift: '|', display: '\\ |' },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: '"', display: '2 "' },
        { key: '3', shift: '#', display: '3 #' },
        { key: '4', shift: '$', display: '4 $' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: '&', display: '6 &' },
        { key: '7', shift: '/', display: '7 /' },
        { key: '8', shift: '(', display: '8 (' },
        { key: '9', shift: ')', display: '9 )' },
        { key: '0', shift: '=', display: '0 =' },
        { key: "'", shift: '?', display: "' ?" },
        { key: '«', shift: '»', display: '« »' }
      ],
      [
        { key: 'q', shift: 'Q', display: 'q' },
        { key: 'w', shift: 'W', display: 'w' },
        { key: 'e', shift: 'E', display: 'e' },
        { key: 'r', shift: 'R', display: 'r' },
        { key: 't', shift: 'T', display: 't' },
        { key: 'y', shift: 'Y', display: 'y' },
        { key: 'u', shift: 'U', display: 'u' },
        { key: 'i', shift: 'I', display: 'i' },
        { key: 'o', shift: 'O', display: 'o' },
        { key: 'p', shift: 'P', display: 'p' },
        { key: '+', shift: '*', display: '+ *' },
        { key: '´', shift: '`', display: '´ `' }
      ],
      [
        { key: 'a', shift: 'A', display: 'a' },
        { key: 's', shift: 'S', display: 's' },
        { key: 'd', shift: 'D', display: 'd' },
        { key: 'f', shift: 'F', display: 'f' },
        { key: 'g', shift: 'G', display: 'g' },
        { key: 'h', shift: 'H', display: 'h' },
        { key: 'j', shift: 'J', display: 'j' },
        { key: 'k', shift: 'K', display: 'k' },
        { key: 'l', shift: 'L', display: 'l' },
        { key: 'ç', shift: 'Ç', display: 'ç' },
        { key: 'º', shift: 'ª', display: 'º ª' },
        { key: '~', shift: '^', display: '~ ^' }
      ],
      [
        { key: 'z', shift: 'Z', display: 'z' },
        { key: 'x', shift: 'X', display: 'x' },
        { key: 'c', shift: 'C', display: 'c' },
        { key: 'v', shift: 'V', display: 'v' },
        { key: 'b', shift: 'B', display: 'b' },
        { key: 'n', shift: 'N', display: 'n' },
        { key: 'm', shift: 'M', display: 'm' },
        { key: ',', shift: ';', display: ', ;' },
        { key: '.', shift: ':', display: '. :' },
        { key: '-', shift: '_', display: '- _' }
      ],
      [
        { key: ' ', display: 'Espaço', special: 'space' }
      ]
    ]
  },
  
  // Turc - QWERTY
  tr: {
    name: 'QWERTY (Türkçe)',
    rows: [
      [
        { key: '"', shift: 'é', display: '" é' },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: "'", display: "2 '" },
        { key: '3', shift: '^', display: '3 ^' },
        { key: '4', shift: '+', display: '4 +' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: '&', display: '6 &' },
        { key: '7', shift: '/', display: '7 /' },
        { key: '8', shift: '(', display: '8 (' },
        { key: '9', shift: ')', display: '9 )' },
        { key: '0', shift: '=', display: '0 =' },
        { key: '*', shift: '?', display: '* ?' },
        { key: '-', shift: '_', display: '- _' }
      ],
      [
        { key: 'q', shift: 'Q', display: 'q' },
        { key: 'w', shift: 'W', display: 'w' },
        { key: 'e', shift: 'E', display: 'e' },
        { key: 'r', shift: 'R', display: 'r' },
        { key: 't', shift: 'T', display: 't' },
        { key: 'y', shift: 'Y', display: 'y' },
        { key: 'u', shift: 'U', display: 'u' },
        { key: 'ı', shift: 'I', display: 'ı' },
        { key: 'o', shift: 'O', display: 'o' },
        { key: 'p', shift: 'P', display: 'p' },
        { key: 'ğ', shift: 'Ğ', display: 'ğ' },
        { key: 'ü', shift: 'Ü', display: 'ü' }
      ],
      [
        { key: 'a', shift: 'A', display: 'a' },
        { key: 's', shift: 'S', display: 's' },
        { key: 'd', shift: 'D', display: 'd' },
        { key: 'f', shift: 'F', display: 'f' },
        { key: 'g', shift: 'G', display: 'g' },
        { key: 'h', shift: 'H', display: 'h' },
        { key: 'j', shift: 'J', display: 'j' },
        { key: 'k', shift: 'K', display: 'k' },
        { key: 'l', shift: 'L', display: 'l' },
        { key: 'ş', shift: 'Ş', display: 'ş' },
        { key: 'i', shift: 'İ', display: 'i' },
        { key: ',', shift: ';', display: ', ;' }
      ],
      [
        { key: 'z', shift: 'Z', display: 'z' },
        { key: 'x', shift: 'X', display: 'x' },
        { key: 'c', shift: 'C', display: 'c' },
        { key: 'v', shift: 'V', display: 'v' },
        { key: 'b', shift: 'B', display: 'b' },
        { key: 'n', shift: 'N', display: 'n' },
        { key: 'm', shift: 'M', display: 'm' },
        { key: 'ö', shift: 'Ö', display: 'ö' },
        { key: 'ç', shift: 'Ç', display: 'ç' },
        { key: '.', shift: ':', display: '. :' }
      ],
      [
        { key: ' ', display: 'Boşluk', special: 'space' }
      ]
    ]
  },
  
  // Polonais - QWERTY
  pl: {
    name: 'QWERTY (Polski)',
    rows: [
      [
        { key: 'ˇ', shift: '˘', display: 'ˇ ˘' },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: '@', display: '2 @' },
        { key: '3', shift: '#', display: '3 #' },
        { key: '4', shift: '$', display: '4 $' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: '^', display: '6 ^' },
        { key: '7', shift: '&', display: '7 &' },
        { key: '8', shift: '*', display: '8 *' },
        { key: '9', shift: '(', display: '9 (' },
        { key: '0', shift: ')', display: '0 )' },
        { key: '-', shift: '_', display: '- _' },
        { key: '=', shift: '+', display: '= +' }
      ],
      [
        { key: 'q', shift: 'Q', display: 'q' },
        { key: 'w', shift: 'W', display: 'w' },
        { key: 'e', shift: 'E', display: 'e' },
        { key: 'r', shift: 'R', display: 'r' },
        { key: 't', shift: 'T', display: 't' },
        { key: 'y', shift: 'Y', display: 'y' },
        { key: 'u', shift: 'U', display: 'u' },
        { key: 'i', shift: 'I', display: 'i' },
        { key: 'o', shift: 'O', display: 'o' },
        { key: 'p', shift: 'P', display: 'p' },
        { key: '[', shift: '{', display: '[ {' },
        { key: ']', shift: '}', display: '] }' }
      ],
      [
        { key: 'a', shift: 'A', display: 'a' },
        { key: 's', shift: 'S', display: 's' },
        { key: 'd', shift: 'D', display: 'd' },
        { key: 'f', shift: 'F', display: 'f' },
        { key: 'g', shift: 'G', display: 'g' },
        { key: 'h', shift: 'H', display: 'h' },
        { key: 'j', shift: 'J', display: 'j' },
        { key: 'k', shift: 'K', display: 'k' },
        { key: 'l', shift: 'L', display: 'l' },
        { key: 'ł', shift: 'Ł', display: 'ł' },
        { key: ';', shift: ':', display: '; :' },
        { key: "'", shift: '"', display: "' \"" }
      ],
      [
        { key: 'z', shift: 'Z', display: 'z' },
        { key: 'x', shift: 'X', display: 'x' },
        { key: 'c', shift: 'C', display: 'c' },
        { key: 'v', shift: 'V', display: 'v' },
        { key: 'b', shift: 'B', display: 'b' },
        { key: 'n', shift: 'N', display: 'n' },
        { key: 'm', shift: 'M', display: 'm' },
        { key: ',', shift: '<', display: ', <' },
        { key: '.', shift: '>', display: '. >' },
        { key: '/', shift: '?', display: '/ ?' }
      ],
      [
        { key: 'ą', shift: 'Ą', display: 'ą' },
        { key: 'ć', shift: 'Ć', display: 'ć' },
        { key: 'ę', shift: 'Ę', display: 'ę' },
        { key: ' ', display: 'Spacja', special: 'space' },
        { key: 'ń', shift: 'Ń', display: 'ń' },
        { key: 'ó', shift: 'Ó', display: 'ó' },
        { key: 'ś', shift: 'Ś', display: 'ś' },
        { key: 'ź', shift: 'Ź', display: 'ź' },
        { key: 'ż', shift: 'Ż', display: 'ż' }
      ]
    ]
  },
  
  // Russe - ЙЦУКЕН
  ru: {
    name: 'ЙЦУКЕН (Русский)',
    rows: [
      [
        { key: 'ё', shift: 'Ё', display: 'ё' },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: '"', display: '2 "' },
        { key: '3', shift: '№', display: '3 №' },
        { key: '4', shift: ';', display: '4 ;' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: ':', display: '6 :' },
        { key: '7', shift: '?', display: '7 ?' },
        { key: '8', shift: '*', display: '8 *' },
        { key: '9', shift: '(', display: '9 (' },
        { key: '0', shift: ')', display: '0 )' },
        { key: '-', shift: '_', display: '- _' },
        { key: '=', shift: '+', display: '= +' }
      ],
      [
        { key: 'й', shift: 'Й', display: 'й' },
        { key: 'ц', shift: 'Ц', display: 'ц' },
        { key: 'у', shift: 'У', display: 'у' },
        { key: 'к', shift: 'К', display: 'к' },
        { key: 'е', shift: 'Е', display: 'е' },
        { key: 'н', shift: 'Н', display: 'н' },
        { key: 'г', shift: 'Г', display: 'г' },
        { key: 'ш', shift: 'Ш', display: 'ш' },
        { key: 'щ', shift: 'Щ', display: 'щ' },
        { key: 'з', shift: 'З', display: 'з' },
        { key: 'х', shift: 'Х', display: 'х' },
        { key: 'ъ', shift: 'Ъ', display: 'ъ' }
      ],
      [
        { key: 'ф', shift: 'Ф', display: 'ф' },
        { key: 'ы', shift: 'Ы', display: 'ы' },
        { key: 'в', shift: 'В', display: 'в' },
        { key: 'а', shift: 'А', display: 'а' },
        { key: 'п', shift: 'П', display: 'п' },
        { key: 'р', shift: 'Р', display: 'р' },
        { key: 'о', shift: 'О', display: 'о' },
        { key: 'л', shift: 'Л', display: 'л' },
        { key: 'д', shift: 'Д', display: 'д' },
        { key: 'ж', shift: 'Ж', display: 'ж' },
        { key: 'э', shift: 'Э', display: 'э' },
        { key: '\\', shift: '/', display: '\\ /' }
      ],
      [
        { key: 'я', shift: 'Я', display: 'я' },
        { key: 'ч', shift: 'Ч', display: 'ч' },
        { key: 'с', shift: 'С', display: 'с' },
        { key: 'м', shift: 'М', display: 'м' },
        { key: 'и', shift: 'И', display: 'и' },
        { key: 'т', shift: 'Т', display: 'т' },
        { key: 'ь', shift: 'Ь', display: 'ь' },
        { key: 'б', shift: 'Б', display: 'б' },
        { key: 'ю', shift: 'Ю', display: 'ю' },
        { key: '.', shift: ',', display: '. ,' }
      ],
      [
        { key: ' ', display: 'Пробел', special: 'space' }
      ]
    ]
  },
  
  // Ukrainien - ЙЦУКЕН
  uk: {
    name: 'ЙЦУКЕН (Українська)',
    rows: [
      [
        { key: "'", shift: '₴', display: "' ₴" },
        { key: '1', shift: '!', display: '1 !' },
        { key: '2', shift: '"', display: '2 "' },
        { key: '3', shift: '№', display: '3 №' },
        { key: '4', shift: ';', display: '4 ;' },
        { key: '5', shift: '%', display: '5 %' },
        { key: '6', shift: ':', display: '6 :' },
        { key: '7', shift: '?', display: '7 ?' },
        { key: '8', shift: '*', display: '8 *' },
        { key: '9', shift: '(', display: '9 (' },
        { key: '0', shift: ')', display: '0 )' },
        { key: '-', shift: '_', display: '- _' },
        { key: '=', shift: '+', display: '= +' }
      ],
      [
        { key: 'й', shift: 'Й', display: 'й' },
        { key: 'ц', shift: 'Ц', display: 'ц' },
        { key: 'у', shift: 'У', display: 'у' },
        { key: 'к', shift: 'К', display: 'к' },
        { key: 'е', shift: 'Е', display: 'е' },
        { key: 'н', shift: 'Н', display: 'н' },
        { key: 'г', shift: 'Г', display: 'г' },
        { key: 'ш', shift: 'Ш', display: 'ш' },
        { key: 'щ', shift: 'Щ', display: 'щ' },
        { key: 'з', shift: 'З', display: 'з' },
        { key: 'х', shift: 'Х', display: 'х' },
        { key: 'ї', shift: 'Ї', display: 'ї' }
      ],
      [
        { key: 'ф', shift: 'Ф', display: 'ф' },
        { key: 'і', shift: 'І', display: 'і' },
        { key: 'в', shift: 'В', display: 'в' },
        { key: 'а', shift: 'А', display: 'а' },
        { key: 'п', shift: 'П', display: 'п' },
        { key: 'р', shift: 'Р', display: 'р' },
        { key: 'о', shift: 'О', display: 'о' },
        { key: 'л', shift: 'Л', display: 'л' },
        { key: 'д', shift: 'Д', display: 'д' },
        { key: 'ж', shift: 'Ж', display: 'ж' },
        { key: 'є', shift: 'Є', display: 'є' },
        { key: '\\', shift: '/', display: '\\ /' }
      ],
      [
        { key: 'я', shift: 'Я', display: 'я' },
        { key: 'ч', shift: 'Ч', display: 'ч' },
        { key: 'с', shift: 'С', display: 'с' },
        { key: 'м', shift: 'М', display: 'м' },
        { key: 'и', shift: 'И', display: 'и' },
        { key: 'т', shift: 'Т', display: 'т' },
        { key: 'ь', shift: 'Ь', display: 'ь' },
        { key: 'б', shift: 'Б', display: 'б' },
        { key: 'ю', shift: 'Ю', display: 'ю' },
        { key: 'ґ', shift: 'Ґ', display: 'ґ' },
        { key: '.', shift: ',', display: '. ,' }
      ],
      [
        { key: ' ', display: 'Пробіл', special: 'space' }
      ]
    ]
  }
};

export const getKeyboardLayout = (language) => {
  return keyboardLayouts[language] || keyboardLayouts.en;
};
